<template>
  <v-layout row nowrap :class="borderBottom">
    <div style="width:100%;display: contents;">
      <div style="display: inline-block;float: left;">
        <v-text-field type="number" :required="required" :rules="[rules.checkCampo]" @focus="changeFocus(true)"
          @blur="changeFocus(false)" name="m3" :label="cantidadtxt" v-model="numericValue" @keypress="validateInput()"
          class="vnis_input numberStyleInput data-colorcorp1" :min="min" :max="max" debounce="500"></v-text-field>
      </div>
      <div style="display: inline-block;float: left;">
        <div style="font-size:14px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div style="width:50px;display: inline-block;float: right;margin-top: 0px; height:50px; margin-right:5px">
          <v-btn flat @click.prevent="increaseNumber()" color="grey darken-1" icon
            style="height:18px;width:18px;margin:0px">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn flat @click.prevent="decreaseNumber()" color="grey darken-1" icon
            style="height:18px;width:18px;margin:0px">
            <v-icon>remove</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'NumberTextFieldSpinner',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 10,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    },
    inputClass: {
      default: 'vnis__input',
      type: String
    },
    buttonClass: {
      default: 'vnis__button',
      type: String
    },
    integerOnly: {
      default: false,
      type: Boolean
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      numericValue: this.value,
      cantidadtxt: 'Cant',
      borderBottom: 'border-bottom:1px solid #AAAAAA; height:50px',
      existError: false,
      existFocus: false,
      rules: {
        /*
         * Regla para comprobar numero de presupuestos
         */
        checkCampo: (value) => {
          if (((value === undefined) || (value === null) || (value === '')) && (this.required)) {
            this.borderBottom = 'border-bottom:2px solid #FF0000; height:50px'
            this.$refs['increaseButton'].style = 'color:red'
            this.$refs['decreaseButton'].style = 'color:red'
            this.$refs['labelError'].style = 'margin-top: 10px;color:red;display:'
            this.existError = true
            return this.$t('campoRequerido')
          } else {
            if (this.existFocus) {
              this.borderBottom = 'border-bottom:2px solid #43A047; height:50px'
              this.$refs['increaseButton'].style = 'color:#43A047'
              this.$refs['decreaseButton'].style = 'color:#43A047'
              this.$refs['labelError'].style = 'display:none'
              this.existError = false
            }
            return true
          }
        }
      }
    }
  },
  watch: {
    /**
     * Comprueba si el valor es numerico
     */
    numericValue: function (val, oldVal) {
      if (val !== '') {
        if (val <= this.min) {
          this.numericValue = parseInt(this.min)
        }
        if (val >= this.max) {
          this.numericValue = parseInt(this.max)
        }
        if (val <= this.max && val >= this.min) {
          this.$emit('input', parseFloat(val), oldVal)
        }
      }
    },
    /**
     * Comprueba las modificaciones de value
     */
    value: {
      handler() {
        this.numericValue = this.value
      }
    }
  },
  methods: {
    /**
     * Incrementa un numero
     */
    increaseNumber() {
      const temp = parseFloat(this.numericValue) + parseFloat(this.step)
      this.numericValue = temp.toFixed(2)
    },
    /**
     * Decrementa un numero
     */
    decreaseNumber() {
      const temp = parseFloat(this.numericValue) - parseFloat(this.step)
      this.numericValue = temp.toFixed(2)
    },
    /**
     * Comprueba si es integer
     */
    isInteger(evt) {
      if (!evt) {
        evt = window.event
      }
      let key = evt.keyCode || evt.which
      key = String.fromCharCode(key)
      const regex = /[0-9]/
      if (!regex.test(key)) {
        evt.returnValue = false
        if (evt.preventDefault) {
          evt.preventDefault()
        }
      }
    },
    /**
     * Comprueba si es numero
     */
    isNumber(evt) {
      if (!evt) {
        evt = window.event
      }
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
        evt.preventDefault()
        return false
      } else {
        return true
      }
    },
    /**
     * Valida la entrada de datos
     */
    validateInput(evt) {
      if (this.integerOnly === true) {
        this.isInteger(evt)
      } else {
        this.isNumber(evt)
      }
    },
    /**
     * Cambia el foco
     */
    changeFocus(focus) {
      this.existFocus = focus
      if (!this.existError) {
        if (focus) {
          this.borderBottom = 'data-NTFSpinnerBorderBottomActive'
        } else {
          this.borderBottom = 'data-NTFSpinnerBorderBottomDesactive'
        }
      }
    }
  }
}
</script>

<style>
*,
*::after,
*::before {
  box-sizing: border-box;
}

.vnis_input {
  -webkit-appearance: none;
  /*border: 1px solid #eeeeee;*/
  font-size: 16px;
  height: 40px;
  margin: 0px;
  outline: none;
  text-align: center;
  /*
  -webkit-outer-spin-button,
  -webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }*/
}

.vnis_button {
  -webkit-appearance: none;
  transition: background 0.5s ease;
  border: 0;
  color: #999999;
  cursor: pointer;
  font-size: 20px;
  height: 40px;
  margin: 0;
  outline: none;
  width: 40px;
  /*&:hover {
    background: lighten(#333333, 10%);
  }
  */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.numberStyleInput .input-group__details {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components_datadec/NumberTextFieldSpinner.vue